export default __webpack_public_path__ + "static/media/Anuphan-Regular.22b4d3b5.eot";